import React, { useState, ChangeEvent, useRef } from 'react';
import { Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store';
import { updateField } from '../store/personalSlice';
import { Street } from '../interfaces/store';

const Personal: React.FC = () => {
  const [avatarLoading, setAvatarLoading] = useState(false);
  const [hideFields, setHideFields] = useState(false);
  const [avatarError, setAvatarError] = useState<string | null>(null);
   const formData = useSelector((state: RootState) => state.personal);
    const dispatch = useDispatch();
    const maritalStatusOptions = [
        { value: '', label: 'Select status' },
        { value: 'single', label: 'Single' },
        { value: 'married', label: 'Married' },
        { value: 'divorced', label: 'Divorced' },
        { value: 'widowed', label: 'Widowed' },
        { value: 'separated', label: 'Separated' },
        { value: 'registered', label: 'Registered Partnership' },
    ];

   const streetRef = useRef<Street>({
    street: '',
    postal: '',
    city: '',
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
  
    if (name === 'street' || name === 'postal' || name === 'city') {
      streetRef.current[name] = value;
  
      const { street, postal, city } = streetRef.current;
  
      if (street && postal && city) {
        const fullStreet = `${street} ${postal}, ${city}`;
        dispatch(updateField({ name: 'street', value: fullStreet }));
      } else if(street){
        dispatch(updateField({ name: 'street', value: street }));
      }
    } else {
      dispatch(updateField({ name: name as keyof typeof formData, value }));
    }
  };
  const handleSelect = (e: ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    dispatch(updateField({ name: name as keyof typeof formData, value }))
  };


const handleAvatarChange = (e: ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

  if (!file.type.startsWith('image/')) {
    setAvatarError('Please upload a valid image file.');
    return;
  }

  if (file.size > 5 * 1024 * 1024) { // 5MB limit
    setAvatarError('Image is too large. Max size is 5MB.');
    return;
  }

  setAvatarError(null);
  setAvatarLoading(true);

  const reader = new FileReader();
  reader.onloadend = () => {
    dispatch(updateField({ name: 'avatar', value: reader.result as string }));
    setAvatarLoading(false);
  };
  reader.onerror = () => {
    setAvatarError('Failed to read file. Please try again.');
    setAvatarLoading(false);
  };
  reader.readAsDataURL(file);
};

  return (
    <div>
      <h2 className="mb-4">Personal</h2>
      <Form>
        <Form.Check
            type="checkbox"
            label="Hide personal fields"
            checked={hideFields}
            onChange={(e) => setHideFields(e.target.checked)}
        />
        {!hideFields &&   <>
        <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                      onPaste={(e: any) => {
                        e.preventDefault();
                        alert('copy pasting is not allowed')
                        return false;
                      }}
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter first name" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formDescription">
                  <Form.Label>Describe yourself</Form.Label>
                  <Form.Control
                      onPaste={(e: any) => {
                        e.preventDefault();
                        alert('copy pasting is not allowed')
                        return false;
                      }}
                      as='textarea'
                      rows={6}
                      type="text"
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      placeholder="Describe yourself" />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formAvatar">
                      <Form.Label>Profile Picture</Form.Label>
                      <Form.Control type="file" accept="image/*" onChange={handleAvatarChange} />
                  </Form.Group><Form.Group className="mb-3" controlId="formEmail">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        onPaste={(e: any) => {
                          e.preventDefault();
                          alert('copy pasting is not allowed')
                          return false;
                        }}
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter email" />
                  </Form.Group><Form.Group className="mb-3" controlId="formPhone">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                          onPaste={(e: any) => {
                            e.preventDefault();
                            alert('copy pasting is not allowed')
                            return false;
                          }}
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Enter phone number" />
                  </Form.Group><Form.Group className="mb-3" controlId="formStreet">
                      <Form.Label>Street</Form.Label>
                      <Form.Control
                          onPaste={(e: any) => {
                            e.preventDefault();
                            alert('copy pasting is not allowed')
                            return false;
                          }}
                          type="text"
                          name="street"
                          value={formData.street}
                          onChange={handleChange}
                          placeholder="Enter street address" />
                  </Form.Group><Form.Group className="mb-3" controlId="formPostal">
                      <Form.Label>Postal Code</Form.Label>
                      <Form.Control
                          onPaste={(e: any) => {
                            e.preventDefault();
                            alert('copy pasting is not allowed')
                            return false;
                          }}
                          type="text"
                          name="postal"
                          value={formData.postal}
                          onChange={handleChange}
                          placeholder="Enter postal code" />
                  </Form.Group><Form.Group className="mb-3" controlId="formCity">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                          onPaste={(e: any) => {
                            e.preventDefault();
                            alert('copy pasting is not allowed')
                            return false;
                          }}
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          placeholder="Enter city" />
                  </Form.Group><Form.Group className="mb-3" controlId="formBirthday">
                      <Form.Label>Birthday</Form.Label>
                      <Form.Control onPaste={(e: any) => {
                        e.preventDefault();
                        alert('copy pasting is not allowed')
                        return false;
                      }} type="date" name="birthday" value={formData.birthday} onChange={handleChange} />
                  </Form.Group><Form.Group className="mb-3" controlId="formBirthplace">
                      <Form.Label>Birthplace</Form.Label>
                      <Form.Control onPaste={(e: any) => {
                        e.preventDefault();
                        alert('copy pasting is not allowed')
                        return false;
                      }} name="birthplace" value={formData.birthplace} onChange={handleChange} />
                  </Form.Group><Form.Group className="mb-3" controlId="formLicense">
                      <Form.Label>Driver's License</Form.Label>
                      <Form.Control onPaste={(e: any) => {
                        e.preventDefault();
                        alert('copy pasting is not allowed')
                        return false;
                      }} name="license" value={formData.license} onChange={handleChange} />
                  </Form.Group><Form.Group className="mb-3" controlId="formNationality">
                      <Form.Label>Nationality</Form.Label>
                      <Form.Control name="nationality" value={formData.nationality} onChange={handleChange} />
                  </Form.Group><Form.Group className="mb-4" controlId="formMaritalStatus">
                      <Form.Label>Marital Status</Form.Label>
                      <Form.Select name="maritalStatus" value={formData.maritalStatus} onChange={handleSelect}>
                          {maritalStatusOptions.map(option => (
                              <option key={option.value} value={option.value}>
                                  {option.label}
                              </option>
                          ))}
                      </Form.Select>
                  </Form.Group></>}
      </Form>
    </div>
  );
};

export default Personal;
